'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useDevice } from '@/contexts/DeviceContext';
import { initGPT, injectAd } from '@/lib/gpt-loader';
import { HeroAdSlot } from '@/lib/types/articleTemplate';

/**
 * Full-bleed in-image ad overlay — the Builder admin's HeroField.heroAd.
 * Reference sites (e.g. kannadaprabha's Hybrid SSP in-image overlay) stack
 * the ad placeholder at height:100%/z-index:2 directly over the hero image
 * (z-index:1) inside the same relatively-positioned box, not as a small
 * corner badge — this mirrors that: the overlay fills the whole image box so
 * the ad's own creative (a fluid/self-sizing "1x1" GPT format) can render at
 * full size. Injects a real GPT slot via injectAd (same helper StickyAds
 * uses) instead of the Builder canvas's dangerouslySetInnerHTML mock, so it
 * actually serves on the live site.
 */
export default function HeroAdOverlay(t0) {
  const $ = _c(4);
  const {
    ad
  } = t0;
  const {
    isMobile,
    deviceDetected
  } = useDevice();
  const containerRef = useRef(null);
  const hasInjectedRef = useRef(false);
  const adCode = deviceDetected ? (isMobile ? ad.mobileCode || ad.desktopCode : ad.desktopCode) || null : null;
  let t1;
  let t2;
  if ($[0] !== adCode) {
    t1 = () => {
      if (!adCode || !containerRef.current || hasInjectedRef.current) {
        return;
      }
      hasInjectedRef.current = true;
      const container = containerRef.current;
      initGPT(() => injectAd(container, adCode, "HeroAd"));
    };
    t2 = [adCode];
    $[0] = adCode;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!deviceDetected || !adCode) {
    return null;
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute inset-0 z-10 flex items-center justify-center overflow-hidden"><div ref={containerRef} className="w-full h-full flex items-center justify-center" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}